export const WindowIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`w-5 h-5 ${className}`}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h12A2.25 2.25 0 0020.25 14.25V3M3.75 12H20.25m-16.5 0V6.75c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25v5.25m0 0V21M12 3v18" />
  </svg>
);